import React from "react";
import {Modal, Button} from "react-bootstrap";
import {InputLabel} from "@material-ui/core";
import TextField from "@material-ui/core/TextField/index";
import {DateTimePicker} from "../../../components/DatePicker";
import {GMTDateConvert} from "../../../../helpers";
import dayjs from "dayjs";

export default function Filter(props) {
    const {onHide, show, filterInputsUpdate, filterInputs, resetFilter, setFilterInputs} = props;

    const handleReset = () => {
        resetFilter();
    }

    return (
        <Modal
            size="sm"
            show={show}
            onHide={onHide}
            aria-labelledby="create"
            centered
            className="modal-right pr-0"
        >
            <Modal.Header closeButton>
                <Modal.Title id="create">Tur məlumatlarını daxil edin.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="col-12 pl-4 pr-4">
                    <div className="row">
                        <div className="col-12 col-md-12 col-lg-12">
                            <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                <TextField
                                    id="code"
                                    name="code"
                                    label="Tur kodu"
                                    placeholder="Tur kodu"
                                    className="w-100"
                                    value={filterInputs.code}
                                    onChange={(e) => filterInputsUpdate(e)}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-12 col-lg-12">
                            <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                <InputLabel htmlFor="expiredDate">Mərcin bitmə tarixi</InputLabel>
                                <DateTimePicker
                                    value={filterInputs.expiredDate ? dayjs(filterInputs.expiredDate) : ""}
                                    onChange={value => setFilterInputs(prevState => ({
                                        ...prevState, expiredDate: value ? GMTDateConvert(value) : ""
                                    }))}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-12 col-lg-12">
                            <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                <InputLabel htmlFor="resultedDate">Turun bitmə tarixi</InputLabel>
                                <DateTimePicker
                                    value={filterInputs.resultedDate ? dayjs(filterInputs.resultedDate) : ""}
                                    onChange={value => setFilterInputs(prevState => ({
                                        ...prevState, resultedDate: value ? GMTDateConvert(value) : ""
                                    }))}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-12 col-lg-12">
                            <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                <TextField
                                    id="productName"
                                    name="productName"
                                    label="Məhsul adı"
                                    placeholder="Məhsul adı"
                                    className="w-100"
                                    value={filterInputs.productName}
                                    onChange={(e) => filterInputsUpdate(e)}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-12 col-lg-12">
                            <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                <TextField
                                    id="totalAmount"
                                    name="totalAmount"
                                    label="Hovuz məbləği"
                                    placeholder="Hovuz məbləği"
                                    className="w-100"
                                    value={filterInputs.totalAmount}
                                    onChange={(e) => filterInputsUpdate(e)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleReset}>
                    Sıfırla
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
